module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./PartakeActivityView.js"));
	}, "PartakeActivityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PartakeActivityView!./src/pages/Promote/OfflineActivity/ActivityCenter/PartakeActivity/PartakeActivityView.js
// module id = 2100
// module chunks = 367